import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services';
import { WaybillIdView } from '../../../../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { WaybillForeignTrade } from '../../../../models/foreign-trade.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillForeignTradeService {
  constructor(private http: WrapperHttpService) {}

  getCustomsDocuments(waybillIdView: WaybillIdView): Observable<WaybillForeignTrade> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.CustomsDocuments
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }
}
